import { render, staticRenderFns } from "./DonutChart37.vue?vue&type=template&id=1bd97c6b&scoped=true&"
import script from "./DonutChart37.vue?vue&type=script&lang=js&"
export * from "./DonutChart37.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd97c6b",
  null
  
)

export default component.exports